import React from "react";
import { ImageViewer } from "react-image-viewer-dv";
import { FiExternalLink } from "react-icons/fi";

const Projects = ({ items }) => {
  return (
    <div className="row portfolio-cont" data-aos="fade-up" data-aos-delay="100">
      {items.map((menuItem) => {
        const { id, title, category, image, url } = menuItem;
        return (
          <div className="col-lg-4 col-md-6 portfolio-item filter-app" key={id}> {/* Added key here */}
            <div className="portfolio-wrap">
              <ImageViewer>
                <img src={image} className="img-fluid project-image" alt={title} />
              </ImageViewer>

              <div className="portfolio-links">
                <a href={url} title="More Details">
                  <FiExternalLink />
                </a>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Projects;
